/* istanbul ignore file */
import { BackButton } from '@components/Button';
import { Footer } from '@components/Footer';
import { OrderDetails } from '@pages/OrdersPages/components/OrderDetails/OrderDetails';
import { Background, ContentContainer } from '@pages/OrdersPages/styles';
import { Route, useHistory, useRouteMatch } from 'react-router-dom';
import { MainTemplate } from 'src/templates/MainTemplate';
import MyOrders from './MyOrders';

export default function MyOrdersPage() {
  const { path } = useRouteMatch();
  const { goBack } = useHistory();
  return (
    <MainTemplate>
      <Background>
        <ContentContainer>
          <BackButton onClick={goBack} />
          <Route exact path={path}>
            <MyOrders />
          </Route>
          <Route path={`${path}/:orderId`}>
            <OrderDetails variant="myOrders" />
          </Route>
        </ContentContainer>
        <Footer />
      </Background>
    </MainTemplate>
  );
}
